import React, { Component, Fragment } from 'react';
import API_URL from '../../ApiUrl';
import axios from 'axios';
import * as Yup from 'yup';

class Home extends Component {

    constructor(props) {
        super(props);
        this.state = {
            fullname: '',
            email: '',
            no_wa: '',
            age: '',
            program_type: '',
            program_code: '',
            batch: '',
            errors: {},
            selectedOption: '',
            referal_code: ''
        }
    }

    validationSchema = Yup.object({
        fullname: Yup.string().required('Name is required'),
        email: Yup.string().email('Invalid email').required('Email is required'),
        no_wa: Yup.number().required('Phone Number is required'),
        age: Yup.string().required('Age is required'),
        program_code: Yup.string().required('Program Name is required'),
    });

    handleChange(e) {
        this.setState({
            [e.target.name]:e.target.value
        });
    }

    handleChangeAge(e) {
        this.setState({
            age: e.target.value,
            program_type: '',
            program_code: '',
            batch: '',
        });
    }

    handleChangeProgramType(e) {
        this.setState({
            program_code: e.target.value,
            batch: ''
        }); 
    }

    register = async (e) => {
        e.preventDefault();

        const { fullname, email, no_wa, age, program_code, batch, referal_code } = this.state;

        try {
            await this.validationSchema.validate({ fullname, email, no_wa, age, program_code }, { abortEarly: false });
            var formData = new FormData();
            formData.append('nama_lengkap', fullname);
            formData.append('email', email);
            formData.append('no_wa', no_wa);
            formData.append('age', age);
            formData.append('program_code', program_code);
            formData.append('batch', batch);
            formData.append('referal_code', referal_code);

            axios.post(API_URL.superStudent+'ihms/register', formData, {
                headers: { 
                    'Accept': 'application/json'
                }
            })
            .then(response => response.data)
            .then(result => {
                window.snap.pay(result, {
                    onSuccess: function(result){console.log('success');console.log(result);},
                    onPending: function(result){console.log('pending');console.log(result);},
                    onError: function(result){console.log('error');console.log(result);},            
                    onClose: function(){console.log('customer closed the popup without finishing the payment');}
                })
                this.setState({ errors: {} });
            })
            .catch(error => {
                console.log(error);
            })
        } catch (validationError) {
            const errors = {};
            validationError.inner.forEach((err) => {
                errors[err.path] = err.message;
            });
            this.setState({ errors });
        }
    }

    render() {
        const { errors } = this.state;
        return (
            <div>
                <section className='banner-lg' id="banner">
                    <div className='container'>
                        <div className='row text-white' style={{marginTop: '300px', marginBottom: '200px'}}>
                            <div className='col-lg-5'>
                                <h1><strong>IHMS</strong></h1>
                                <h3>International Hotel Management School</h3>
                            </div>
                        </div>
                    </div>
                </section>
                <main id='main'>
                    <section id='register'>
                        <div className='container'>
                            <div className='row mb-5'>
                                <div className='col-lg-6'>
                                    <h2 className='text-left'>Register</h2>
                                    <form className='mt-4'>
                                        <div className='form-group mb-3'>
                                            <label>Fullname</label>
                                            <input type='text' className='form-control' name='fullname' onChange={(e) => this.handleChange(e)} value={this.state.fullname}></input>
                                            {errors.fullname && <div style={{ color: 'red' }}>{errors.fullname}</div>}
                                        </div>
                                        <div className='form-group mb-3'>
                                            <label>Email</label>
                                            <input type='email' className='form-control' name='email' onChange={(e) => this.handleChange(e)} value={this.state.email}></input>
                                            {errors.email && <div style={{ color: 'red' }}>{errors.email}</div>}
                                        </div>
                                        <div className='form-group mb-3'>
                                            <label>No. Whatsapp</label>
                                            <input type='number' className='form-control' name='no_wa' onChange={(e) => this.handleChange(e)} value={this.state.no_wa}></input>
                                            {errors.no_wa && <div style={{ color: 'red' }}>{errors.no_wa}</div>}
                                        </div>
                                        <div className='form-group mb-3'>
                                            <label>Referal Code (Optional)</label>
                                            <input type='text' className='form-control' name='referal_code' onChange={(e) => this.handleChange(e)} value={this.state.referal_code}></input>
                                        </div>
                                        <div className='form-group mb-3'>
                                            <div className='row'>
                                                <div className='col-lg-6'>
                                                    <label>
                                                        <span style={{marginRight: '10px'}}>Adult</span>
                                                        <input type='radio' name='age' id='age' html='age' value='1' onChange={(e) => this.handleChangeAge(e)} />
                                                    </label>
                                                </div>
                                                <div className='col-lg-6'>
                                                    <label>
                                                        <span style={{marginRight: '10px'}}>Kids</span>
                                                        <input type='radio' name='age' id='age' html='age' value='2' onChange={(e) => this.handleChangeAge(e)} />
                                                    </label>
                                                </div>
                                            </div>
                                            {errors.age && <div style={{ color: 'red' }}>{errors.age}</div>}
                                        </div>
                                        { 
                                            this.state.age === '1' ? 
                                            <>
                                                <div className='form-group mb-3'>
                                                    <label>Program Type</label>
                                                    <select className='form-control' name='program_code' onChange={(e) => this.handleChangeProgramType(e)} value={this.state.program_code}>
                                                        <option value=''>-- Choose Program --</option>
                                                        <option value='PRGM0001'>Hospitality & Management Program</option>
                                                        <option value='PRGM0002'>Culinary Program</option>
                                                        <option value='PRGM0003'>⁠Summer Course (Unlock The Secrets of Global Cuisine)</option>
                                                    </select>
                                                    {errors.program_code && <div style={{ color: 'red' }}>{errors.program_code}</div>}
                                                </div>
                                                {
                                                    this.state.program_code === 'PRGM0003' ? 
                                                        <div className='form-group mb-3'>
                                                            <label>Batch</label>
                                                            <select className='form-control' name='batch' onChange={(e) => this.handleChange(e)} value={this.state.batch}>
                                                                <option value=''>-- Choose Batch --</option>
                                                                <option value='BATCH0003'>08 - 12 Desember 2025 (09:00)</option>
                                                                <option value='BATCH0004'>15 - 19 Desember 2025 (09:00)</option>
                                                            </select>
                                                            {errors.batch && <div style={{ color: 'red' }}>{errors.batch}</div>}
                                                        </div>
                                                    : ""
                                                }
                                            </>
                                            :
                                            this.state.age === '2' ? 
                                                <>
                                                    <div className='form-group mb-3'>
                                                    <label>Program Type</label>
                                                        <select className='form-control' name='program_type' onChange={(e) => this.handleChangeProgramType(e)} value={this.state.program_type}>
                                                            <option value=''>-- Choose Program --</option>
                                                            <option value='PRGM0004'>⁠Summer Course (Cookery & Pastry Class)</option>
                                                        </select>
                                                        {errors.program_type && <div style={{ color: 'red' }}>{errors.program_type}</div>}
                                                    </div>
                                                    <div className='form-group mb-3'>
                                                        <label>Batch</label>
                                                        <select className='form-control' name='batch' onChange={(e) => this.handleChange(e)} value={this.state.batch}>
                                                            <option value=''>-- Choose Batch --</option>
                                                            <option value='BATCH0003'>08 - 12 Desember 2025 (14:00)</option>
                                                            <option value='BATCH0004'>15 - 19 Desember 2025 (14:00)</option>
                                                        </select>
                                                        {errors.batch && <div style={{ color: 'red' }}>{errors.batch}</div>}
                                                    </div>
                                                </>
                                            :''
                                        }
                                    </form>
                                </div>
                                <div className='col-lg-6'>
                                    <h2 className='text-left'>Preview Program</h2>
                                    <table className='mt-4' style={{fontWeight: 'bold'}}>
                                        <tr>
                                            <td>Fullname</td>
                                            <td>:</td>
                                            <td>{this.state.fullname}</td>
                                        </tr>
                                        <tr>
                                            <td>Email</td>
                                            <td>:</td>
                                            <td>{this.state.email}</td>
                                        </tr>
                                        <tr>
                                            <td>Phone Number (wa)</td>
                                            <td>:</td>
                                            <td>{this.state.no_wa}</td>
                                        </tr>
                                        <tr>
                                            <td>Age</td>
                                            <td>:</td>
                                            <td>{this.state.age === '1' ? 'Adult' : this.state.age === '2' ? 'Kids' : ''}</td>
                                        </tr>
                                        <tr>
                                            <td>Program Name</td>
                                            <td>:</td>
                                            <td>
                                                {
                                                    this.state.program_code === 'PRGM0001' ? 
                                                    'Hospitality Management'
                                                    :
                                                    this.state.program_code === 'PRGM0002' ? 
                                                    'Culinary'
                                                    :
                                                    this.state.program_code === 'PRGM0003' ? 
                                                    'Unlock The Secrets of Global Cuisine'
                                                    :
                                                    this.state.program_code === 'PRGM0004' ? 
                                                    'Cookery & Pastry Class'
                                                    :
                                                    ''
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Batch</td>
                                            <td>:</td>
                                            <td>
                                                {
                                                    this.state.batch === 'BATCH0001' ? 
                                                    '08 - 12 Desember 2025 (09:00)'
                                                    :
                                                    this.state.batch === 'BATCH0002' ? 
                                                    '15 - 19 Desember 2025 (09:00)'
                                                    : 
                                                    this.state.batch === 'BATCH0003' ? 
                                                    '08 - 12 Desember 2025 (14:00)'
                                                    :
                                                    this.state.batch === 'BATCH0004' ? 
                                                    '15 - 19 Desember 2025 (14:00)'
                                                    : ''
                                                }
                                            </td>
                                        </tr>
                                    </table>
                                    <form onSubmit={this.register}>
                                        <div className='row mt-5'>
                                            <div className='col-lg-8 d-md-flex justify-content-md-start'>
                                                {
                                                    this.state.program_name === 'PRGM0001' ? 
                                                    <h4><b>Rp 500.000 (Admin Fee)</b></h4>
                                                    :
                                                    this.state.program_name === 'PRGM0002' ? 
                                                    <h4><b>Rp 500.000 (Admin Fee)</b></h4>
                                                    :
                                                    this.state.program_name === 'PRGM0003' ? 
                                                    <h4><b>Rp 9.700.000 (Fully Funded)</b></h4>
                                                    :
                                                    this.state.program_name === 'PRGM0004' ? 
                                                    <h4><b>Rp 3.900.000 (Fully Funded)</b></h4>
                                                    :
                                                    ''
                                                }
                                            </div>
                                            <div className='col-lg-4 d-md-flex justify-content-md-end'>
                                                <button className='btn-default' type='submit' on>Submit</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>
            </div>
        )
    }

}

export default (Home);